import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

interface LinkCardProps {
  href: string;
  title: string;
  subtitle?: string;
  imageSrc: string;
  badge?: string;
}

const LinkCard: React.FC<LinkCardProps> = ({ href, title, subtitle, imageSrc, badge }) => {
  const content = (
    <>
      <div className="flex items-center gap-3 sm:p-4 min-w-0">
        <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-black/5 dark:bg-white/5 border border-black/10 dark:border-white/10 flex items-center justify-center p-2 shrink-0 group-hover:bg-black/10 dark:group-hover:bg-white/10 group-hover:scale-105 transition-all">
          <img
            src={imageSrc}
            alt={title}
            className="w-full h-full object-contain filter drop-shadow opacity-90 group-hover:opacity-100 dark:invert-0"
          />
        </div>

        <div className="flex flex-col min-w-0 leading-tight">
          <div className="flex items-center gap-2">
            <span className="font-semibold text-sm sm:text-base tracking-wide truncate group-hover:text-brand-amber transition-colors">
              {title}
            </span>

            {badge && (
              <span className="text-[10px] uppercase font-bold tracking-wider px-1.5 py-0.5 rounded bg-black/5 dark:bg-white/10 text-slate-500 dark:text-slate-300 border border-black/10 dark:border-white/10 shrink-0">
                {badge}
              </span>
            )}
          </div>

          {subtitle && (
            <span className="text-xs sm:text-sm text-slate-500 dark:text-slate-400 truncate mt-0.5">
              {subtitle}
            </span>
          )}
        </div>
      </div>

      <div className="p-1 text-slate-400 group-hover:text-brand-amber group-hover:translate-x-1 transition-all shrink-0">
        <ArrowUpRight className="w-5 h-5" />
      </div>
    </>
  );

  return href.startsWith("/") ? (
    <Link
      to={href}
      className="group relative w-full flex items-center justify-between p-3 sm:p-4 rounded-xl art-card text-slate-800 dark:text-slate-100 hover:text-black dark:hover:text-white transition-all duration-300"
    >
      {content}
    </Link>
  ) : (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="group relative w-full flex items-center justify-between p-3 sm:p-4 rounded-xl art-card text-slate-800 dark:text-slate-100 hover:text-black dark:hover:text-white transition-all duration-300"
    >
      {content}
    </a>
  );
};

export default LinkCard;